import React, { Fragment } from 'react'
import { Form } from 'informed'

import { Text } from 'components/forms'
import Button from 'components/Button'

const ViewList = ({ onSubmit, closeModal }) => {
	return(
		<Form onSubmit={({ view }) => {
			onSubmit(view); closeModal()
		}} render={({ formApi }) => (
			<Fragment>
				<Text field='view' label='Name' />
				<Button text='speichern' status='primary' />
			</Fragment>
		)}/>
	)
}

export default ViewList
